// extracted by mini-css-extract-plugin
module.exports = {"list":"Categories_list__1e8QI"};